/* Copyright IBM Corp. 2017 */
import { ContentItemWithLayout } from './../../../api';
import { bootstrapPutContentWithLayout } from './../../utils/bootstrap.utils';
import { ContentWithLayoutBootstrapDirective } from './rendering.context.bootstrap.directive';

/*
 * Rendering context decorator
 *
 * @Annotation
 */
export function ContentWithLayoutBootstrap(aDirective?: ContentWithLayoutBootstrapDirective):
    (target: any, propertyKey: string) => void {
    // export the decorator function
    return function (target: any, propertyKey: string): void {
        // register access to this property
        bootstrapPutContentWithLayout(target[propertyKey] as ContentItemWithLayout);
    };
}
